export const colorList = [
	'#0086C0',
	'#00C875',
	'#037F4C',
	'#225091',
	'#333333',
	'#401694',
	'#4ECCC6',
	'#5559DF',
	'#579BFC',
	'#66CCFF',
	'#68A1BD',
	'#784BD1',
	'#7E3B8A',
	'#7F5347',
	'#808080',
	'#9AADBD',
	'#9CD326',
	'#A25DDC',
	'#BB3354',
	'#C4C4C4',
	'#CAB641',
	'#E2445C',
	'#FAA1F1',
	'#FDAB3D',
	'#FF158A',
	'#FF5AC4',
	'#FF642E',
	'#FF7575',
	'#FFADAD',
	'#FFCB00'
];

const ColorGenerator = () => {
	let index = 0;

	function getColor() {
		const color = colorList[index];

		index = index === colorList.length - 1 ? 0 : index + 1;

		return color;
	}

	function resetIndex() {
		index = 0;
	}

	return {
		getColor,
		resetIndex
	};
};

export default ColorGenerator();
